import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import { TryAgainMessage } from '@swf/sports/components';
import EventStructuredData from '@swf/sports/components/EventStructuredData/EventStructuredData';
import useMarketUpdates from '@swf/sports/hooks/useMarketUpdates';

import styles from './SportsMarketsWidget.scss';
import MarketGroups from './components/MarketGroups/MarketGroups';
import NoEventsMessage from './components/NoEventsMessage/NoEventsMessage';
import { sportsMarketsWidgetModel, useSportsMarketsWidget } from './model';

const SportsMarketsWidget: WidgetFC = () => {
  const { widgetDispatch, widgetSelect } = useSportsMarketsWidget();
  const competition = useSelector(widgetSelect.competition);
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const marketIds = useSelector(widgetSelect.marketIds);
  const error = useSelector(widgetSelect.errorCode);
  const event = useSelector(widgetSelect.event);
  const eventType = useSelector(widgetSelect.eventType);
  const markets = useSelector(widgetSelect.markets);

  useMarketUpdates(marketIds, widgetDispatch.marketsUpdated);

  if (isLoading && !hasPreloaded) {
    return null;
  }

  if (error === 404) {
    return <NoEventsMessage />;
  }

  if (typeof error !== 'undefined') {
    return <TryAgainMessage />;
  }

  const [market] = Object.values(markets);
  return (
    <>
      <MarketGroups />
      {market && (
        <EventStructuredData
          event={event}
          eventType={eventType}
          market={market}
          competition={competition}
        />
      )}
    </>
  );
};

SportsMarketsWidget.model = sportsMarketsWidgetModel;

export default withWidgetTestId(SportsMarketsWidget, 'sports-markets', {
  className: styles.wrapper
});
